import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyEnUs: MsAdlActivityLabels = {
    Walking: "Walking",
    Cooking: "Cooking",
    Driving: "Driving",
    Shopping: "Shopping",
    Work: "Work",
    Sport: "Sport",
    Housework: "Housework",
    Socialising: "Socializing",
};
